import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Offer } from 'app/models/Offer';
import { SettingsService } from 'app/services/settings.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'mpf-offers-dialog',
  templateUrl: './offers-dialog.component.html',
  styleUrls: ['./offers-dialog.component.scss']
})
export class OffersDialogComponent {
  offers: Offer[] = [
    {
      text: {
        de: 'Kaufe 2 personalsierte Städteposter und erhalte automatisch 10% Rabatt',
        en: '10% off when you buy 2 maps! Automatically applied in the checkout'
      }
    },
    {
      text: {
        de: 'Kaufe 3 personalsierte Städteposter und erhalte automatisch 20% Rabatt',
        en: '20% off when you buy 3 maps! Automatically applied in the checkout'
      }
    }
  ];

  constructor(private dialogRef: MatDialogRef<OffersDialogComponent>, private settings: SettingsService) {}

  getOfferText(offer: Offer) {
    return offer.text[this.settings.getLanguage()];
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/components/offers-dialog/offers-dialog.component.ts